import { useEffect, useMemo, useState } from 'react';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { usePollingInterval } from '@/js/libs/hooks/usePollingInterval';

import { CHECK_STATUS_INTERVAL, STATUS_REQUEST_PATH } from 'src/constants';
import type { StatusApiResponse } from './types';
import { IncidentStatus } from './types';

export const useOngoingIncidentsCheck = (): boolean => {
  const [hasOngoingIncidents, setHasOngoingIncidents] = useState<boolean>(false);

  const load = useCallbackRef(async () => {
    const res = await fetch(STATUS_REQUEST_PATH, {
      credentials: 'omit',
    });

    const data: StatusApiResponse = await res.json();

    setHasOngoingIncidents(
      data.incidents.some((incident) => [IncidentStatus.identified, IncidentStatus.investigating].includes(incident.status)),
    );
  });

  useEffect(() => {
    load();
  }, [load]);

  usePollingInterval(load, { intervalMs: CHECK_STATUS_INTERVAL });

  return useMemo(() => hasOngoingIncidents, [hasOngoingIncidents]);
};
